import React from 'react';
import ReactDOM from 'react-dom';

import styles from './Tooltip.module.css';

import { useState, useRef } from 'react';
import useTooltip from '../../../hooks/useTooltip';

const Tooltip: React.FC<{
    children: React.ReactNode,
    text: string | JSX.Element,
    customStyles?: React.CSSProperties
}> = ({ children, text, customStyles }) => {

    const popupRef = useRef<HTMLDivElement | null>(null);

    const getStylePos = (pos: DOMRect, element: HTMLInputElement) => {
        const elHeight = popupRef.current?.offsetHeight || 24;
        const top = pos.top > window.innerWidth / 2 ?
            pos.top - elHeight - 2 : pos.top  + element.offsetHeight + 2;
        return {
            top: `${top}px`,
            left: `${pos.right - (popupRef.current?.offsetWidth || 60) / 2 - element.offsetWidth / 2}px`
        };
    };

    const { tooltipRef, getStyles } = useTooltip(getStylePos);

    const [visible, setVisible] = useState<boolean>(false);
    const [hoverTooltip, setHoverTooltip] = useState<boolean>(false);

    return (
        <>
            <div
                onMouseEnter={() => setVisible(true)}
                onMouseLeave={() => setVisible(false)}
                className={styles.tooltip}
                ref={tooltipRef}
            >
                {children}
            </div>
            {ReactDOM.createPortal(
                <>
                    <div
                        onClick={e => e.stopPropagation()}
                        onMouseEnter={() => setHoverTooltip(true)}
                        onMouseLeave={() => setHoverTooltip(false)}
                        ref={popupRef}
                        style={{
                            ...getStyles(),
                            visibility: (visible || hoverTooltip) ? 'visible' : 'hidden',
                            ...customStyles
                        }}
                        className={styles.tooltipText}
                    >
                        {text}
                    </div>
                </>, document.getElementById('tooltip') as HTMLElement,
            )}
        </>
    );
};

export default Tooltip;